import _get from 'lodash/get';
import _isArray from 'lodash/isArray';
import _isObject from 'lodash/isObject';

import { COMPONENT_CONFIGURATION_ID_ATTRIBUTE } from '../components/EditPageElementModal/EditPageElementModal.constants';

export function findElementComponentConfigurationIds(element) {
  const ids = new Set();

  function traverse(obj) {
    if (!_isObject(obj) && !_isArray(obj)) return;

    if (_get(obj, COMPONENT_CONFIGURATION_ID_ATTRIBUTE)) {
      ids.add(obj.componentConfigurationId);
    }

    if (_isArray(obj)) {
      obj.forEach(traverse);
    } else if (_isObject(obj)) {
      Object.values(obj).forEach(traverse);
    }
  }

  traverse(element);
  return [...ids];
}
